// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// Add the Firebase products that you want to use
require("firebase/firestore");
require("firebase/auth");

const firebaseConfig = {
    apiKey: "AIzaSyDty6SPTQzkAzounxvnBTalr9Hcb3EKaoU",
    authDomain: "thetafarm-e46e9.firebaseapp.com",
    databaseURL: "https://thetafarm-e46e9.firebaseio.com",
    projectId: "thetafarm-e46e9",
    storageBucket: "thetafarm-e46e9.appspot.com",
    messagingSenderId: "716214304513",
    appId: "1:716214304513:web:33562c44da5abd15b9e500",
    measurementId: "G-WCNCCK0MZ3"
};

firebase.initializeApp(firebaseConfig);


export default firebase;